// extracted by mini-css-extract-plugin
export default {"page":"ZZ-z","cartModal":"_Z-z","checkout":"a0-z","placeholder":"b0-z","account":"c0-z"};